import * as types from '../../mutation-types'
// import lazyLoading from './lazyLoading'
// import charts from './charts'
// import uifeatures from './uifeatures'
// import components from './components'
// import tables from './tables'
import echo from './echo'
import noti from './noti'
import house from './house'
import device from './device'
import parking from './parking'
import nexia from './nexia'
import parcel from './parcel'
import visitor from './visitor'
import visitorVehicle from './visitorVehicle'
import vote from './vote'
import contact from './contact'
import bill from './bill'
import ems from './ems'
import pushnotification from './pushnotification'
import serviceinfo from './serviceinfo'
import elevator from './elevator'
import cctv from './cctv'
import homeiotdashboard from './homeiotdashboard'
import userinfo from './userinfo'
import notificationRequest from './notificationRequest'
import connectorInfo from './connectorInfo'
import centralPage from './centralPage'
import evcharge from './evcharge'
import legalInfo from './legalInfo'
import brandInfo from './brandInfo'
import linkedService from './linkedService'
// show: meta.label -> name
// name: component name
// meta.label: display label

const state = {
  items: [
    // {
    //   name: 'Dashboard',
    //   path: '/dashboard',
    //   meta: {
    //     icon: 'fal fa-tachometer-alt',
    //     link: 'dashboard/index.vue'
    //   },
    //   component: lazyLoading('dashboard', true)
    // },
    // {
    //   name: 'Axios',
    //   path: '/axiosDemo',
    //   meta: {
    //     auth: false,
    //     icon: 'fa-rocket',
    //     link: 'axios/index.vue'
    //   },
    //   component: lazyLoading('axios', true)
    // },
    // charts,
    // uifeatures,
    // components,
    // tables,
    house,
    centralPage,
    device,
    elevator,
    bill,
    brandInfo,
    cctv,
    contact,
    ems,
    evcharge,
    legalInfo,
    linkedService,
    noti,
    notificationRequest,
    parcel,
    parking,
    pushnotification,
    serviceinfo,
    visitor,
    visitorVehicle,
    vote,
    userinfo,
    nexia,
    homeiotdashboard,
    connectorInfo,
    echo
  ]
}

const mutations = {
  [types.EXPAND_MENU] (state, menuItem) {
    if (menuItem.index > -1) {
      if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
        state.items[menuItem.index].meta.expanded = menuItem.expanded
      }
    } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
      menuItem.item.meta.expanded = menuItem.expanded
    }
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/index.js